module.exports = __webpack_public_path__ + "static/media/guide.2e22b5a9.md";


//////////////////
// WEBPACK FOOTER
// ./src/site/guide.md
// module id = 151
// module chunks = 0